// extracted by mini-css-extract-plugin
export default {"input":"Toggle_input__bfGuk","label":"Toggle_label__byN9k"};